import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

import { message } from 'antd';

const label = 'selectOneDriveRootFolder';

const handler = (actions) => {
  openSelectOneDriveRootFolderDialog(actions);
};

const openSelectOneDriveRootFolderDialog = (actions) => {
  const { showDialog, hideDialog, rootContainer, refresh } = actions;

  api
    .getOneDriveFolderChildren({ excludeFiles: true }, () => oneDriveLoginCallback(() => openSelectOneDriveRootFolderDialog(actions), refresh))
    .then((children) => {
      const rawDialogElement = {
        elementType: 'SelectOneDriveRootFolderDialog',
        elementProps: {
          onHide: hideDialog,
          rootContainer: rootContainer,
          children: children,
          getChildren: api.getOneDriveFolderChildren,
          assignRootFolderExternalId: api.assignRootFolderExternalId,
          refresh: refresh,
        },
      };

      showDialog(rawDialogElement);
    });
};

const oneDriveLoginCallback = async (afterSuccess, refresh) => {
  const oneDriveLoginUrl = await api.getOneDriveCodeRequestUrl();

  const oneDriveLoginWindow = window.open(oneDriveLoginUrl, '_blank', 'width=600,height=400');

  if (oneDriveLoginWindow == null) {
    message.error({
      content: 'Your browser blocked the window.',
      className: 'custom-class',
      style: {
        marginTop: '20vh',
      },
    });
  }

  oneDriveLoginWindow.focus();

  localStorage.removeItem('onedrive_login_result');

  const loginResultListener = (ev) => {
    if (ev.key == 'onedrive_login_result') {
      const message = JSON.parse(ev.newValue);
      if (message && message.isSuccess) {
        afterSuccess();
      }
    }

    window.removeEventListener('storage', loginResultListener);
  };

  window.addEventListener('storage', loginResultListener);

  const timer = setInterval(() => {
    if (oneDriveLoginWindow.closed) {
      clearInterval(timer);
      refresh();
    }
  }, 500);
};

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);

  return {
    id: label,
    icon: { icon: icons.setRootFolder },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const resource = actions.getSelectedResources();

      return resource.length === 1 && resource[0].id.toString().endsWith('_onedrive') && resource[0].isSystemFolder === true ? true : false;
    },
    availableInContexts: ['row'],
    handler: () => handler(actions),
  };
};
